import { useEffect, useState } from "react";
import "./SnsCreatePasswordPage.css";

import AuthFooter from "../Shared/AuthFooter/AuthFooter";

import { useAuth } from "../../Context/AuthContext";
import { bindPassword } from "../../Api/Backend/Auth";
import { useNavigate, useLocation } from "react-router-dom";
import { ValidatePassword } from "../../Utils/ValidatePassword";
import SimpleLoader from "../../Components/SimpleLoader/SimpleLoader";

const SnsCreatePasswordPage = () => {
    const navigate = useNavigate();
    const auth = useAuth();
    const location = useLocation();
    const cameFromCallback = location.state?.fromCallback;
    // const cameFromCallback = true;

    const [formData, setFormData] = useState({
        password: "",
        passwordConfirm: "",
    });
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleLaterClick = () => {
        navigate('/');
    };

    const handleRegisterClick = async (e) => {
        e.preventDefault();

        if (errorMessage) {
            alert("비밀번호 필드를 확인하세요.");
            return;
        }

        const { password } = formData;
        setIsLoading(true);

        await bindPassword({
            auth: auth,
            rawPassword: password,
            onSuccess: (data) => {
                console.log("Success:", data);
                navigate('/');
            },
            onError: (error) => {
                alert("Error binding password:", error);
                console.error("Error binding password:", error);
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        const { password, passwordConfirm } = formData;

        const result = ValidatePassword(password, passwordConfirm);
        setErrorMessage(result);
    }, [formData.password, formData.passwordConfirm]);

    useEffect(() => {
        if (!cameFromCallback || !auth?.user?.email) {
            navigate("/", { replace: true });
        }
    }, [cameFromCallback, navigate]);

    return (
        <div className="scp">
            <div className="scp-content">
                <div className="scp-title">SNS 회원 비밀번호 추가등록</div>
                <div className="scp-desc">아래 SNS 계정으로 가입이 완료 되었습니다.</div>
                <div className="scp-desc-2">[선택] 비밀번호 입력방식으로 로그인 할수도 있습니다. 등록하시겠습니까?</div>

                <form className="scp-form">
                    <div className="scp-form-field">
                        <label className="scp-label">이메일주소</label>
                        <div className="scp-static">{auth?.user?.email}</div>
                    </div>

                    <div className="scp-form-field">
                        <label className="scp-label">비밀번호</label>
                        <div className="scp-input-group">
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="비밀번호를 입력해 주세요"
                                disabled={isLoading}
                            />
                            <input
                                type="password"
                                name="passwordConfirm"
                                value={formData.passwordConfirm}
                                onChange={handleChange}
                                placeholder="비밀번호를 한번 더 입력해 주세요"
                                disabled={isLoading}
                            />
                            {errorMessage !== null &&
                                <div className="scp-form-error">{errorMessage}</div>
                            }
                        </div>
                    </div>

                    <div className="scp-actions">
                        <button
                            type="button"
                            className="scp-btn cancel"
                            onClick={handleLaterClick}
                            disabled={isLoading}
                        >
                            나중에
                        </button>
                        <button
                            type="submit"
                            className="scp-btn submit"
                            onClick={handleRegisterClick}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <SimpleLoader />
                            ) : (
                                "비밀번호 등록"
                            )}
                        </button>
                    </div>

                </form>
            </div>

            <div className="scp-footer">
                <AuthFooter />
            </div>
        </div>
    );
};

export default SnsCreatePasswordPage;